// extracted by mini-css-extract-plugin
export default {"container":"ScreenTitle_container__+E-KQ","title":"ScreenTitle_title__vsXte"};